<template>
  <div class="parameters">
    <router-view />
  </div>
</template>

<script>
import { provideImportReportFetchers } from '@invivodf/common/src/contexts/parameters'
import { useDiscountAssociationImportReport, useDiscountImportReport } from '@invivodf/common/src/contexts/discount'

export default {
  name: 'VParameters',
  setup() {
    provideImportReportFetchers(useDiscountImportReport(), useDiscountAssociationImportReport())
  },
}
</script>

<style scoped lang="scss">
.parameters {
  background-color: var(--idf-color-neutral-200);
}
</style>
